export var AccordionVariant;
(function (AccordionVariant) {
    AccordionVariant["DEFAULT"] = "default";
    AccordionVariant["CENTERED"] = "centered";
    AccordionVariant["REVERSE"] = "reverse";
})(AccordionVariant || (AccordionVariant = {}));
//# sourceMappingURL=Accordion.type.js.map